import { Content } from './types'

const formula: Content = {
    type: 'formula',
    name: 'Formule',
}

export default formula
